import { useEffect } from 'react'
import { Outlet } from 'react-router-dom'

import { useAiChat } from '@factorialco/f0-react'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'

import { PageSkeleton } from 'modules/meetings/components/Skeletons/PageSkeleton'
import CollectionsBootstrap from 'modules/meetings/lib/OneononesroutesCollectionsBootstrap'
import { OneOnOnesContextProvider } from 'modules/meetings/lib/context/OneOnOnesContext/OneOnOnesProvider'
import { useOneOnOnesContext } from 'modules/meetings/lib/hooks/useOneOnOnesContext'

const OneOnOnesRootPageWrapper = () => {
  const { canSeeMeetings, loading } = useOneOnOnesContext()

  const { setEnabled } = useAiChat()

  useEffect(() => {
    setEnabled(false)
    return () => setEnabled(true)
  }, [setEnabled])

  if (loading) {
    return <PageSkeleton />
  }

  const authorizeFn = () => {
    return canSeeMeetings
  }

  return (
    <AuthorizeUser authorizeFn={authorizeFn}>
      <Outlet />
    </AuthorizeUser>
  )
}

const OneOnOnesRootPage = () => {
  return (
    <CollectionsBootstrap>
      <OneOnOnesContextProvider>
        <OneOnOnesRootPageWrapper />
      </OneOnOnesContextProvider>
    </CollectionsBootstrap>
  )
}

export default OneOnOnesRootPage
